import $ from "jquery";
import axios from "axios";

$(() => {
    $(".load-more").on("click", function () {
        const id = $(this).data("id");
        // Read the raw attribute rather than the jQuery-parsed object: the field set
        // is a sealed string the server opens, so it has to go back untouched.
        const fields = $(this).attr("data-fields");
        const amountToLoad = parseInt($(this).data("amount-to-load"), 10) || 0;
        if (!fields) {
            return;
        }

        // The server returns the next offset; fall back to counting the DOM only
        // until the first response has been seen.
        const storedNext = $(this).data("next-offset");
        const initialOffset = $(this).data("initial-offset") ?? 0;
        const offset = $(`#${id} .cards .item-card:not([class$="included"])`).length ?? 0;
        const nextOffset =
            typeof storedNext === "number" ? storedNext : initialOffset + offset;
        const masonry = $(this).data("is-masonry") ?? 0;
        const slider = $(this).data("is-slider") ?? 0;
        const textLoadMore = $(this).data("text-load-more");
        const textLoading = $(this).data("text-loading");
        const textLoadFailed = $(this).data("text-load-failed");

        // Data to send back to WordPress.
        const formData = new FormData();
        formData.append("action", "wpsoup_load_posts_by_ajax");
        formData.append("security", frameworkGlobal.nonce);
        formData.append("offset", nextOffset);
        formData.append("fields", fields);
        // Only present on markup rendered before payloads were sealed: a page cached
        // back then is still served to browsers running this bundle.
        const legacySignature = $(this).attr("data-fields-signature");
        if (legacySignature) {
            formData.append("fields_signature", legacySignature);
        }

        // Change button text to loading text.
        $(`#${id} .load-more`).html(textLoading);

        // Do request.
        axios
            .post(frameworkGlobal.ajaxurl, formData)
            .then(({ data }) => {
                // The endpoint returns { html, next_offset, has_more }. Tolerate the
                // older raw-HTML shape so a cached page served with older JS still works.
                const payload =
                    data && typeof data === "object" && data.data ? data.data : null;
                const html = payload ? payload.html : data;

                // Create a placeholder div to store retrieved posts.
                const container = document.createElement("div");
                container.innerHTML = html;

                // Extract only the item-card elements from the response, skipping
                // the mobile slider: when cards_in_slider_mobile is on the block
                // renders the same cards a second time, and appending both would
                // duplicate every card on screen.
                const newCards = Array.from(
                    container.querySelectorAll(".item-card"),
                ).filter((el) => !el.closest(".card-mobile-slider"));

                // Append the card elements
                newCards.forEach((card) => {
                    $(`#${id} .cards`).append(card.cloneNode(true));
                });

                // Prefer the server's answer; the counting heuristic below is only
                // a fallback for the old response shape. A theme override of the
                // Blade partial may not emit the amount attribute, and an empty ACF
                // field yields 0, so treat "unknown" as "keep the button".
                if (payload && typeof payload.next_offset === "number") {
                    $(this).data("next-offset", payload.next_offset);
                }

                const done = payload
                    ? payload.has_more === false
                    : newCards.length === 0 ||
                      (amountToLoad > 0 && newCards.length < amountToLoad);

                if (done) {
                    $(`#${id} .load-more-container`).remove();
                } else {
                    // Update button text back to load more
                    $(`#${id} .load-more`).html(textLoadMore);
                }

                // Reinit masonry or equalizer.
                if (slider) {
                    const instance = cardSliders.find((x) => x.id === id).instance;
                    instance.update();
                }

                // Reinit masonry or equalizer.
                if (masonry) {
                    const container = masonryGrids.find((x) => x.id === id).container;
                    window.masonryGridPolyfill(container, true, true);
                } else {
                    Foundation.reInit("equalizer");
                }
            })
            .catch((error) => {
                $(`#${id} .load-more`).html(textLoadFailed);
            });
    });
});
